import { render, staticRenderFns } from "./MaintenanceHistoryNew.vue?vue&type=template&id=6b401e88&scoped=true"
import script from "./MaintenanceHistoryNew.vue?vue&type=script&lang=js"
export * from "./MaintenanceHistoryNew.vue?vue&type=script&lang=js"
import style0 from "./MaintenanceHistoryNew.vue?vue&type=style&index=0&id=6b401e88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b401e88",
  null
  
)

export default component.exports